import React from 'react';
import KeyReferenceDataCards
  from '../KeyReferenceDataCards/KeyReferenceDataCards';
import s from './CBDView.less';
import SidePanel from '../SidePanel/SidePanel';
import SummarySubSections from '../SummarySubSections/SummarySubSections';
import FobTable from '../FobTable/FobTable';
import StackedBarChart from '../StackedBarChart/StackedBarChart';
import getProperty from 'lodash.get';

const SummarySectionContainer = props => (
  <div className={`${s.summarySection} row`}>
    <div className={`col-xs-9`}>
      <div className={`row ${s.topRow}`}>
        <div className={`col-xs-6 ${s.leftContainer}`}>
          <FobTable
            SummarySectionData={getProperty (props, ['ui', 'cbdUIMapping', 'SummarySectionData'])}
            fobData={getProperty (props, ['ui', 'cbdUIMapping', 'fobData'])}
          />
        </div>
        <div className={`col-xs-6`}>
          <div className={`${s.referenceCardWrapper}`}>
            <div className={`${s.referenceCardRow} shadowBox`}>
              <KeyReferenceDataCards
                  boldData={props.ui.cbdUIMapping.boldReferenceCard}
                  plainData={props.ui.cbdUIMapping.plainReferenceCard}
                  headerData={props.ui.cbdUIMapping.headerReferenceData}
              />
            </div>
          </div>
        </div>
      </div>
      {props.ui.cbdUIMapping.SummarySectionData &&
        <div className={`shadowBox ${s.stackedBarChartWrapper}`}>
          <StackedBarChart
            summaryData={props.ui.cbdUIMapping.SummarySectionData}
            totalFob={getProperty (props, [
              'ui',
              'cbdUIMapping',
              'fobData',
              'FOB',
            ])}
            totalFobWithTooling={getProperty (props, [
              'ui',
              'cbdUIMapping',
              'fobData',
              'FOB with Tooling',
            ])}
          />
        </div>}
      <SummarySubSections
        SummarySectionData={props.ui.cbdUIMapping.SummarySectionData}
        totalFob={getProperty (props, ['ui', 'cbdUIMapping', 'fobData', 'FOB'])}
      />
    </div>
    <div className={`col-xs-3`}>
      <SidePanel
        SideBarSummaryData={props.ui.cbdUIMapping.SideBarSummaryData}
      />
    </div>
  </div>
);

export default SummarySectionContainer;



// WEBPACK FOOTER //
// ./src/components/MainContent/SummarySectionContainer.js